import React, { useContext } from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { PreparingView } from '@bingads-webui-react/copilot-ui-base';
import { I18nContext } from '@bingads-webui/copilot-i18n';

import { ConversationList } from './conversation-list';
import { ErrorDialog } from './error-dialog';
import { ConversationListShimmer } from './conversation-list-shimmer';
import { useChatHistoryViewStyles } from './styles';
import { ChatHistoryHeader } from './chat-history-header';
import { NoConversationsView } from './no-conversations-view';
import { useChatHistoryController } from './hooks/use-chat-history-controller';
import type { ChatHistoryViewProps } from './types';

export const ChatHistoryView = ({
  uid, cid, onConversationClick, onClose, onBack, logger, activeConversationId, onDeleteActiveConversation, onStartNewChat, appPerfMarker, isRefreshUIEnabled, isNavRefreshNew,
}: ChatHistoryViewProps) => {
  const i18n = useContext(I18nContext);
  const styles = useChatHistoryViewStyles();

  const {
    conversations,
    hasError,
    setHasError,
    isFirstLoad,
    isResumeConvInProgress,
    onConversationClick: handleConversationClick,
    onConversationDelete,
    onConversationRename,
    loadMore,
  } = useChatHistoryController({
    uid,
    cid,
    logger,
    activeConversationId,
    onConversationClick,
    onDeleteActiveConversation,
    appPerfMarker,
  });

  return (
    <>
      <ErrorDialog
        open={hasError}
        setOpen={setHasError}
      />

      {isResumeConvInProgress
        ? (
          <div className={mergeClasses(styles.resumeConversationLoading, 'resume-conversation-loading')}>
            <PreparingView
              onClose={onClose}
              showRefreshButton={false}
              loadingText={i18n?.getString(_TL_('Preparing Copilot...'))}
              i18n={i18n}
              isNavRefreshNew={isNavRefreshNew}
            />
          </div>
        )
        : (
          <>
            <ChatHistoryHeader
              onClose={onClose}
              onBack={onBack}
              isRefreshUIEnabled={isRefreshUIEnabled}
              isNavRefreshNew={isNavRefreshNew}
            />
            {isFirstLoad ?
              <div className={isNavRefreshNew ? styles.contentNavRefresh : undefined}><ConversationListShimmer /></div> :
              <>
                {conversations.length > 0 ?
                  <ConversationList
                    conversations={conversations}
                    onConversationClick={handleConversationClick}
                    onDelete={onConversationDelete}
                    onRename={onConversationRename}
                    onLoadMore={loadMore}
                    activeConversationId={activeConversationId}
                    appPerfMarker={appPerfMarker}
                  />
                  : <NoConversationsView
                      onStartNewChat={onStartNewChat}
                  />}
              </>
            }
          </>
        )
      }
    </>
  );
};
